const getters = {
  getIsGlobalDownloading(state) {
    return state.isGlobalDownloading;
  },
};

export default getters;
